import { render } from "./GeneralErr.vue?vue&type=template&id=37208201"
import script from "./GeneralErr.vue?vue&type=script&lang=js"
export * from "./GeneralErr.vue?vue&type=script&lang=js"
script.render = render

export default script